<template>
  <div>
    <!--#region -- Header ---->
    <div>
      <div class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
        <div v-if="checkNewES()">
          <a class="btn btn-primary" target="_blank"
             :href="safeUrl(`${frontEndUrlToUse}engineering-service/new`)">New</a>
          <div v-if="!accessSfdc">
            <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                    v-b-tooltip.hover.right
                    title="You are going to create an engineering service without SalesForce account."></button>
          </div>
        </div>

        <div v-else>
          <button type="button"
                  class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                  v-b-tooltip.hover.right
                  title="You don't have the permission to create an Engineering Service.
                  Please contact system administrators power@getac.com and alice.cy.lee@getac.com.tw if you still want to raise a ticket."></button>
        </div>

        <!-- v-if="accessSfdc"
  <div v-else>
    <b-button disabled size="lg"
              variant="dark"
              style="
              width: 50.1px;
              height: 33.5px;
              font-size: 14px;
              padding: 6px;">New</b-button>
    <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
            v-b-tooltip.hover.right
            title="You don't have permission to create an engineering service">
    </button>
  </div>-->
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-4">
              <div class="label mt-2">Status</div>
              <div class="row">
                <div class="col-5">
                  <div class="sub-label">ES Status:</div>
                  <gtc-multi-select v-model="es_status" key-field="value" text-field="text"
                                    :options="es_status_options" select-class="w-100"></gtc-multi-select>
                </div>
                <div class="col-7">
                  <div class="sub-label">Source:</div>
                  <gtc-multi-select v-model="sourceChosen" key-field="value" text-field="text"
                                    :options="sourceInSfdc" select-class="w-100"></gtc-multi-select>
                </div>

              </div>
              <div class="label mt-2">SFDC Type</div>
              <div class="row">
                <div class="col-8">
                  <div class="sub-label">Request Type:</div>
                  <gtc-multi-select v-model="requestTypeChosen" key-field="value" text-field="text"
                                    :options="requestTypeInSfdc" select-class="w-100"></gtc-multi-select>
                </div>
                <!--
                                <div class="col-4">
                <div class="sub-label">Type:</div>
                <gtc-multi-select v-model="issueTypeChosen" key-field="value" text-field="text"
                                  :options="issueTypeInSfdc" select-class="w-100"></gtc-multi-select>
              </div>
              -->

              </div>

            </div>
            <div class="col">
              <div class="label mt-2">Owner</div>
              <div class="row">
                <div class="col-3">
                  <div class="sub-label">GRO Site:</div>
                  <b-form-select v-model="GRO" :options="GRO_options" @change="onChangeGRO" label="GRO Site:"></b-form-select>
                </div>
                <div class="col-3">
                  <div class="sub-label">GRO Owner (L1):</div>
                  <div v-if="GROOwnerList.length == 0">
                    <b-form-input v-model="GRO_owner" placeholder="" label="GRO Owner:" trim></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GRO_owner" :options="GROOwnerList" label="GRO Owner:"></b-form-select>
                  </div>
                </div>
                <div class="col-3">
                  <div class="sub-label">GTC Owner (L2):</div>
                  <div v-if="GTCOwnerList.length == 0">
                    <b-form-input v-model="GTC_owner" placeholder="" label="GTC Owner:" trim></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GTC_owner" :options="GTCOwnerList" label="GTC Owner:"></b-form-select>
                  </div>
                </div>

                <div class="col-3"><div class="sub-label"></div></div>
              </div>
              <div class="label mt-2">Search</div>
              <div class="row">
                <!--<div class="col-3">
                <div class="sub-label">Model:</div>
                <gtc-multi-select v-model="model" key-field="value" text-field="text"
                                  :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
              </div>-->
                <div class="col-6">
                  <div class="sub-label">ES Create Date:</div>
                  <div class="d-flex">
                    <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" />
                    <span class="font-weight-bold align-self-center">～</span>
                    <input type="text" class="form-control" v-model="date_to" v-datepicker:from="date_from" />
                  </div>
                </div>
                <div class="col-3">
                  <div class="sub-label">Customer:</div>
                  <b-form-input v-model="customer"
                                placeholder=""
                                label="Customer"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">
                    Keywords:
                    <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" style="margin-top: -4px;"
                            v-b-tooltip.hover.topright title="Service ID, FTIE ID, Opty ID, Opty Name, etc"></button>
                  </div>

                  <b-form-input v-model="keywords"
                                placeholder=""
                                label="Keywords:"
                                trim>
                  </b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto align-self-end" style="width: 11.5rem">
          <b-button @click="search(false)" variant="primary">Search</b-button>
          <!--
                    <b-button @click="resetFilterCondition()" variant="btn btn-outline-primary">Reset</b-button>
        -->

        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex">
        <div class="h5 font-weight-bold">{{ rows }} Results</div>
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem"
           v-if="searchedData !== null">
        <b-table :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(es_id)="data">
            <a class="link"
               target="_blank"
               :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ data.item.opty_obj_id }`)">
              {{ data.item.es_id }}
            </a>
          </template>
          <template #cell(opty_name)="data">
            <gtc-opportunity :opportunityId="data.item.opty_master_id"
                             :opportunityName="data.item.opty_name" />
          </template>
          <template #cell(ftie_id)="data">
            <div class="row">
              <div class="col-4 align-self-end">
                <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }ftie/ftie-page/${ data.item.ftie_id }`)">{{ data.item.ftie_id }}</a>
              </div>

            </div>
          </template>
          <!-- Before action group, only assign function available for assigners
          <template #cell(action)="data">
            <button v-if="data.item.ftie_id!=null && data.item.request_detail_id!=null"
                    type="button" class="btn btn-sm btn-primary"
                    @click="showAssignTicketModal(data.item.ftie_id, data.item.request_detail_id,data.item.gtc_owner)">
              Assign
            </button>
          </template>
        -->

          <template #cell(actionGroup)="data">
            <button :id="`assign-rule-button-${data.index}`" type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-more"></button>
            <b-popover :target="`assign-rule-button-${data.index}`"
                       custom-class="menu" triggers="focus">
              <div class="list-group list-group-flush">
                <button v-if="checkAssignerPermission && data.item.ftie_id!=null && data.item.request_detail_id!=null"
                        type="button"
                        class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                        v-b-tooltip.hover.right title="Assign Ticket"
                        @click="showAssignTicketModal(data.item.ftie_id, data.item.request_detail_id,data.item.gtc_owner)">
                </button>
                <button v-if="checkCloneAbility && data.item.opty_obj_id !==null"
                        type="button"
                        class="btn btn-sm btn-link p-0 btn-svg gtc-icon-copy"
                        v-b-tooltip.hover.right title="Clone Ticket"
                        @click="showCloneEsModal(data.item.opty_obj_id, data.item)">
                </button>
                <!--
                <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                          @click="$emit('deleteAssignRuleModal', data.item)"></button>
                          @click="$emit('editFtieAssignModal', data.item, 'Copy')"
              -->

              </div>
            </b-popover>
          </template>
        </b-table>
      </div>
      <div class="d-flex pr-3">
        <div class="ml-auto">
          <b-pagination v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :disabled="pageDisabled"
                        :limit="pageLimit"
                        @change="pageChange">
          </b-pagination>
        </div>
      </div>
      <div class="row mx-n1 align-items-center pr-3">
        <div class="px-1 col-auto ml-auto">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
        </div>
        <div class="px-1 col-auto">
          <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div class="px-1 col-auto">rows per page</div>
      </div>
    </div>
    <b-modal centered ok-title="Assign" @ok="assignTicket"
             cancel-title="Cancel"
             ok-variant="primary"
             ref="AssignTicketModal" title="Assign ticket"
             button-size="sm">

      <div class="row">
        <div class="col-auto">
          <div class="label mt-2">Assign Ticket Owner:</div>
        </div>
        <div class="col-auto">
          <b-form-select v-model="assigned_ticket_owner" :options="GTCOwnerList" label="Ticket Owner:"></b-form-select>
        </div>
      </div>
    </b-modal>
    <!-- #region: clone ES ticket -->
    <b-modal centered ok-variant="primary"
             ref="UnableToClone"
             hide-footer title="Unable to Clone"
             button-size="sm">
      <div>
        <p>
          <b>Sorry, the clone function only support the ticket created after the system migration (2022Q4)</b>.
        </p>
        <p>
          This ticket was too old to clone!
        </p>
      </div>
    </b-modal>

    <b-modal centered ok-title="Clone" @ok="doCloneES"
             cancel-title="Cancel"
             ok-variant="primary"
             ref="CloneEsModal" title="Clone Ticket"
             button-size="sm">
      <div>Are you sure want to clone Engineering Service with ID {{es_shorten_id_to_be_clone}}?</div>
      <br />
      <div>Please note that once you click clone, the new ES will be generated, but you still need to click Submit so that the ES will transfer to FTIE ticket.</div>
    </b-modal>
    <!-- #endregion: clone ES ticket-->
    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'engineering-services',
    data() {
      return {
        function_name: 'Engineering Services',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        accessSfdc: false,
        keywords: '',
        customer: '',
        authUrl: '',
        frontendUrl: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userInfo: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        GRO_options_default: '',
        GRO_options: [
          { value: '', text: 'ALL' },
          { value: 'GDE', text: 'GDE' },
          { value: 'Getac', text: 'Getac' },
          { value: 'GFR', text: 'GFR' },
          { value: 'GMD-AFME', text: 'GMD-AFME' },
          { value: 'GMD-AU', text: 'GMD-AU' },
          { value: 'GMD-E.ASIA', text: 'GMD-E.ASIA' },
          { value: 'GMD-IN', text: 'GMD-IN' },
          { value: 'GMD-IT', text: 'GMD-IT' },
          { value: 'GMD-LATAM', text: 'GMD-LATAM' },
          { value: 'GMD-RUCEE', text: 'GMD-RUCEE' },
          { value: 'GMD-S.ASIA', text: 'GMD-S.ASIA' },
          { value: 'GMD-W.EU', text: 'GMD-W.EU' },
          { value: 'GML', text: 'GML' },
          { value: 'GTK', text: 'GTK' },
          { value: 'GUK', text: 'GUK' },
          { value: 'GUSA', text: 'GUSA' },
          { value: 'OTHERS', text: 'OTHERS' },
        ],
        GRO: '',
        GROText: '',
        GTCOwnerList: [],
        GROOwnerList: [],
        model_options: [],
        model: '',
        loadingCnt: 0,
        sourceInSfdc: [
          { value: 'Pre-Sales', text: 'Pre-Sales' },
          { value: 'Post-Sales', text: 'Post-Sales' },
          { value: 'Sector Solution', text: 'Sector Solution' }
        ],
        sourceChosen: [
          { value: 'Pre-Sales', text: 'Pre-Sales' },
          { value: 'Post-Sales', text: 'Post-Sales' },
          { value: 'Sector Solution', text: 'Sector Solution' }
        ],
        issueTypeInSfdc: [],
        issueTypeChosen: [],
        requestTypeInSfdc: [],
        requestTypeChosen: [],
        ticket_type_options: [{ value: 'Pre-sales', text: 'Pre-sales' }, { value: 'Post-sales', text: 'Post-sales' },
        { value: 'Customization Support', text: 'Customization Support' }, { value: 'Sector Solution', text: 'Sector Solution' }],
        ticket_type: '',
        ticket_status_options: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        ticket_status: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }],
        es_status: [
          { value: 'New', text: 'New' },
          { value: 'Open', text: 'Open' },
          { value: 'In-Process', text: 'In-Process' },
          { value: 'Deferred', text: 'Deferred' },
          { value: 'Close', text: 'Close' }
        ],
        es_status_options: [
          { value: 'New', text: 'New' },
          { value: 'Open', text: 'Open' },
          { value: 'In-Process', text: 'In-Process' },
          { value: 'Deferred', text: 'Deferred' },
          { value: 'Close', text: 'Closed' },
        ],
        es_id_to_be_clone: null,
        es_obj_to_be_clone: null,
        es_shorten_id_to_be_clone: null,
        reason_text: null,

        already_first_search_flag: false,
        fields: [
          {
            key: 'es_id', label: 'Service ID',
            thClass: 'align-middle',
            thStyle: { 'min-width': '9rem !important' },
            sortable: true
          },

          {
            key: 'request_type', label: 'Request Type',
            thClass: 'align-middle',
            thStyle: { 'min-width': '8rem !important' },
            sortable: true
          },
          /*
          {
            key: 'issue_type', label: 'Issue Type', thClass: 'align-middle',
            thStyle: { 'min-width': '8rem !important' }, sortable: true
          },
        */

          {
            key: 'source', label: 'Source', thClass: 'align-middle',
            thStyle: { 'min-width': '6.5rem !important' },
            sortable: true
          },

          { key: 'opty_name', label: 'Opty Name', thClass: 'align-middle', sortable: true },
          //{ key: 'site', label: 'GRO', thClass: 'align-middle', sortable: true },
          { key: 'primary_info.account_name', label: 'Customer', thClass: 'align-middle', sortable: true },
          //{ key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: true },
          //{ key: 'device', label: 'Device', thClass: 'align-middle', sortable: true },
          //{ key: 'type', label: 'FTIE Type', thClass: 'align-middle', sortable: true },
          {
            key: 'es_ticket_status', label: 'Status',
            thClass: 'align-middle',
            thStyle: { 'min-width': '6.5rem !important' },
            sortable: true
          },
          { key: 'ftie_id', label: 'FTIE', thClass: 'align-middle', sortable: true },
          //{ key: 'gro_owner', label: 'Gro Owner', thClass: 'align-middle', sortable: true },
          //{ key: 'escalated_date', label: 'Escalate Date', thClass: 'align-middle', sortable: true },
          //{ key: 'close_date', label: 'Closed Date', thClass: 'align-middle', sortable: true },
          //{ key: 'nre_exist', label: 'Action', thClass: 'align-middle', sortable: false },
          { key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true },
          { key: 'actionGroup', label: 'Actions', thClass: 'align-middle', thStyle: { 'min-width': '2.5rem !important' }, sortable: false }
        ],
        searchBy: null,
        searchContent: null,
        searchedData: [],
        searchedDataFtie: null,
        // GRO_owner_gusa: 'jared.wood',
        GRO_owner: 'ALL',
        GTC_owner: 'ALL',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        totalCount: '',
        closeSubTicketFTIE: null,
        closeSubTicketReason: '',
        assign_ticket_owner_options: [],
        assigned_ticket_owner:''
      }
    },
    created() {
      let self = this;


    },
    computed: {
      rows() {
        return this.totalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.checkAssignerPermission();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadingCnt = 0;
      this.get_sfdc_type_list();
      this.get_ftie_gtc_owner_list();
      ///engineering-services/dashboard/search/:searchBy/:searchContent
      if (this.$route.params.searchBy) {
        this.searchBy = this.$route.params.searchBy;
        console.log("this.searchBy = ");
        console.log(this.searchBy);
        if (this.$route.params.searchContent) {
          this.searchContent = this.$route.params.searchContent;
          console.log("this.searchContent = ");
          console.log(this.searchContent);
          this.search(false);
        }
      }
    },
    methods: {
      prdEnv() {
        if ('PRD' === this.$session.get('mode')) {
          return true;
        } else {
          return false;
        }
      },
      showCloneEsModal(sfdc_es_obj_id, es_obj) {
        let self = this;
        self.es_id_to_be_clone = null;
        self.es_obj_to_be_clone = null;
        self.es_shorten_id_to_be_clone = null;
        self.es_id_to_be_clone = sfdc_es_obj_id;
        self.es_obj_to_be_clone = JSON.parse(JSON.stringify(es_obj));
        if (es_obj !== null && _.get(es_obj, 'es_id', null) !== null) {
          self.es_shorten_id_to_be_clone = _.get(es_obj, 'es_id', null);
        }
        else {
          self.$refs['UnableToClone'].show();
        }

        if (es_obj !== null
          && (null === _.get(es_obj, 'primary_info.es_purpose', null)
          || null === _.get(es_obj, 'primary_info.matching_issue', null)
            || null === _.get(es_obj, 'primary_info.requirement_stage', null))
        ) {
          self.$refs['UnableToClone'].show();
        } else {
          self.$refs['CloneEsModal'].show();
        }
      },
      doCloneES(bvModalEvt) {
        console.log("doCloneES START!");
        let self = this;
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang']
        let create_by = self.login_user_name;
        if (defaultGmlSaMembers.includes(self.login_user_name)) {
          create_by = 'gmlsa.gml';
        }
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/engineering-service/clone/';
        let request_data = {
          input_info: JSON.parse(JSON.stringify(self.es_obj_to_be_clone)),
          site: self.$session.get('user_site'),
          create_by: create_by,
          es_id_in_opty_obj: self.es_id_to_be_clone,
          action: 'clone',
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let save_success = false;
        let es_id = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
              //save_success = _.get(res, 'save_success', false);
              es_id = res.es_id;
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.es_id_to_be_clone = null;
            if (save_success && es_id !== null) {
              window.location.href = self.frontEndUrlToUse + 'engineering-service/opty-id/' + es_id;
            }
          })
        self.$nextTick(() => {
          self.$refs['CloneEsModal'].hide();
        })
      },
      onChangeGRO(GRO) {
        let groText = GRO;
        if ('' === GRO) {
          groText = 'ALL';
        }
        var options = this.$session.get('options');
        let indexStr = GRO + "." + 'GRO_owners';
        this.GROOwnerList = _.get(this.ownerSelectionDic, indexStr, options.gro_owner_opt_list);
        //this.GROOwnerList = this.ownerSelectionDic[GRO]['GRO_owners'];
      },
      get_sfdc_type_list() {
        let self = this;
        let url = self.$root.baseUrl + '/engineering-service/options/sfdc-type/';
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let issue_type_list = [];
        let request_type_list = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            if (response.status === 200) {
              issue_type_list = JSON.parse(res['issue_type_list']);
              request_type_list = JSON.parse(res['request_type_list']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {

            var requestTypeMultiOptions = new Array();
            for (i = 0; i < request_type_list.length; i++) {
              requestTypeMultiOptions.push({ value: request_type_list[i], text: request_type_list[i] })
            }
            self.requestTypeInSfdc = requestTypeMultiOptions; //this.model_options.concat(model_option_new);
            self.requestTypeChosen = JSON.parse(JSON.stringify(requestTypeMultiOptions));

            var issueTypeMultiOptions = new Array();
            for (i = 0; i < issue_type_list.length; i++) {
              issueTypeMultiOptions.push({ value: issue_type_list[i], text: issue_type_list[i] })
            }
            self.issueTypeInSfdc = issueTypeMultiOptions;
            self.issueTypeChosen = JSON.parse(JSON.stringify(issueTypeMultiOptions));
            eventHub.$emit('loading', false);

          });
      },
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        //this.GTCOwnerList = options.gtc_owner_opt_list;
        this.GROOwnerList = options.gro_owner_opt_list;
        this.ownerSelectionDic = options.owner_dic_with_region_key;

        console.log("options.gtc_owner_default:");
        console.log(options.gtc_owner_default);
        console.log("options.gro_owner_default:");
        console.log(options.gro_owner_default);


        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);

        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;
        let indexStr = this.GROText + "." + 'GRO_owners';
        this.GROOwnerList = _.get(this.ownerSelectionDic, indexStr, options.gro_owner_opt_list);
        console.log("this.GROOwnerList = ");
        console.log(this.GROOwnerList);

        this.GTC_owner = options.gtc_owner_default;
        this.GRO_owner = options.gro_owner_default;


        let request_data = {
          user_name: this.login_user_name,
          user_email: user_email,
          user_functions: this.userFunctions,
          user_roles: this.userRoles,
          user_sites: this.userSites,
        };
        this.$axios.post(this.$root.baseUrl + '/engineering-service/permission/sfdc/', request_data) // , { params }
          .then((response) => {
            var res = response.data;
            //console.log(res);
            let userIdInSfdc = res['sfdc_user_id']; //JSON.parse(res['es_ticket_info_list']);
            let accessSfdc = res['sfdc_permission'];
            this.accessSfdc = accessSfdc;
          }, (error) => {
            console.log(error);
            this.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            if ((this.userRoles && _.indexOf(this.userRoles, 'Admin') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'SFDC_USERS') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM_Leader') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'GRO_SA_Leader') > -1)
              || (this.userRoles && _.indexOf(this.userRoles, 'HQ_Sales') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'ES PM Leader') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'Tech Leader') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'Getac Sales Manager') > -1)
              || (this.userFunctions && _.indexOf(this.userFunctions, 'GRO TOP Manager') > -1)
            ) {
              this.accessSfdc = true;
            }
            console.log("user_functions:");
            console.log(user_functions);
            console.log("user_roles:");
            console.log(user_roles);
            console.log("this.accessSfdc:");
            console.log(this.accessSfdc);
          })
      },

      search(assign_refresh_flag) {
        if (this.loadingCnt == 0) {
          this.already_first_search_flag = false;
          this.loadingCnt = this.loadingCnt + 1;
        }
        if (!assign_refresh_flag) {
          this.currentPage = 1;
        }
        this.getEngineeringServices();
      },
      pageChange(page) {
        this.currentPage = page;
        this.getEngineeringServices(); // api call
      },
      perPageChange() {
        this.currentPage = 1;
        this.getEngineeringServices(); // api call
      },
      getEngineeringServices() {
        let self = this;
        //let url = self.$root.baseUrl + '/engineering-service/dashboard/';
        let es_status_selected = new Array();
        if (self.es_status.length == 0) {
          es_status_selected.push("")
        }
        else {
          for (i = 0; i < self.es_status.length; i++) {
            es_status_selected.push(self.es_status[i]['value'])
          }
        }
        let request_data = {
          record_per_page: self.perPage,
          page_index: self.currentPage,
          gro_owner: self.GRO_owner,
          gtc_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          account: self.customer,
          es_status: es_status_selected,
          source_in_sfdc: self.sourceChosen,
          request_type_in_sfdc: self.requestTypeChosen,
          site: self.GRO,
          search_by: self.searchBy,
          search_content: self.searchContent,
          keywords: self.keywords
        };
        self.searching = true;
        let searchedData = [];
        let totalCount = 0;

        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(self.$root.baseUrl + '/engineering-service/dashboard/all/', request_data) // , { params }
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['es_ticket_info_list']);
              totalCount = parseInt(res['es_ticket_total_count']);
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.totalCount = totalCount;
            // console.log("self.searchedData = ");
            // console.log(self.searchedData);

          })
      },
      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.model = '';
        //self.GRO = '';
        self.GRO_owner = 'ALL';//'ALL';
        self.GTC_owner = 'ALL';
        self.date_from = '';
        self.date_to = '';
        self.es_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }];
        self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }];
        if (self.searchBy !== null || self.searchContent !== null) {
          self.searchBy = null;
          self.searchContent = null;
          self.$router.push('/engineering-services/dashboard');
        }
      },

      redirectToEtoDashboard(ftie_id) {
        let self = this;
        console.log(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
        window.open(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
      },
      checkAssignerPermission() {
        let self = this;
        if (self.userRoles.includes('ASSIGNER') || self.userRoles.includes('Admin')) {
          return true;
          //self.fields.push({ key: 'gtc_owner', label: 'GTC Owner', thClass: 'align-middle', sortable: true });
          //self.fields.push({ key: 'action', label: 'Action', thClass: 'align-middle', thStyle: { 'min-width': '10% !important' }, sortable: false });
        } else {
          return false;
        }
      },
      checkCloneAbility() {
        let self = this;
        return true;
      },
      checkNewES() {
        let self = this;
        if ((self.userRoles && _.indexOf(self.userRoles, 'Admin') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ES_PM') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'ES_PM_Leader') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'GRO_SA') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'GRO_SA_Leader') > -1)
          || (self.userRoles && _.indexOf(self.userRoles, 'HQ_Sales') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'ES PM Leader') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'Getac Sales Manager') > -1)
          || (self.userFunctions && _.indexOf(self.userFunctions, 'GRO TOP Manager') > -1)
        ) {
          //         || (this.userRoles && _.indexOf(this.userRoles, 'SFDC_USERS') > -1)
          return true
        } else {
          return false
        }
      },
      showAssignTicketModal(ftie_id, request_detail_id,gtc_owner) {
        let self = this;
        self.$refs['AssignTicketModal'].show()
        self.current_request_detail_id = request_detail_id;
        self.current_ftie_id = ftie_id;
        self.assigned_ticket_owner = gtc_owner;
      },
      assignTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/reassign-ticket/';

        let request_data = {
          request_detail_id: self.current_request_detail_id,
          assigned_ticket_owner: self.assigned_ticket_owner,
          login_user_name: self.login_user_name,
          ftie_id: self.current_ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.search(true);
            }
          })
        self.$nextTick(() => {
          self.$refs['AssignTicketModal'].hide();
        })
      },

      get_ftie_gtc_owner_list() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              self.GTCOwnerList = JSON.parse(res['gtc_owner_list']);
              self.GTCOwnerList.unshift('ALL');
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/engineering-service-process/EngineeringServiceDashboard.vue